import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
    type IsoAndUnixTimestamp,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { userIdZodSchema, type UserId } from "@@/shared/users/user-id";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

type ReservationReference = {
    readonly _id: string;
    readonly _type: "RESERVATION_REFERENCE";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly userId: UserId;
    readonly reservationId: string;
};

const reservationReferenceFactory = (params: {
    userId: UserId;
    reservationId: string;
}): ReservationReference => {
    const reservationReference: ReservationReference = {
        _id: generateId({ prefix: "reservation_reference__" }),
        _createdAt: nowIsoAndUnix(),
        _type: "RESERVATION_REFERENCE",
        ...params,
    };

    return reservationReference;
};

const reservationReferenceZodSchema: z.ZodSchema<ReservationReference> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("RESERVATION_REFERENCE"),
        _createdAt: isoAndUnixZodSchema,
        userId: userIdZodSchema,
        reservationId: idZodSchema,
    });

export { reservationReferenceFactory, reservationReferenceZodSchema };
export type { ReservationReference };
